// extracted by mini-css-extract-plugin
export default {"container":"DurationPicker__container___LiK3n","durationDropdown":"DurationPicker__durationDropdown___bRg_e"};